var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "enable-background": "new 0 0 24 24",
        height: _vm.size,
        viewBox: "0 -1 24 24",
        width: _vm.size
      }
    },
    [
      _c("path", { attrs: { fill: "none", d: "M0 0h24v24H0z" } }),
      _c("path", {
        attrs: {
          fill: _vm.color,
          d:
            "M5 17v2h14v-2zm4.79-4.81h4.44l.98 2.81h1.9L12.98 4h-1.97L6.88 15h1.9zm2.16-6.15h.09l1.6 4.55h-3.29z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }